import React from 'react';
import StudentsManager from '../../components/Admin/StudentsManager';

const StudentsPage = () => {
  return <StudentsManager />;
};

export default StudentsPage;